import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ValidatorStatusFieldsFragmentDoc } from './validator-status.graphql';
export type GqlOrFieldsFragment = { createdAt: string, description?: string | null, ibanAddress?: string | null, ibanBank?: string | null, ibanBic?: string | null, ibanNumber?: string | null, id: string, payBeforeDate?: string | null, paymentAccountKind?: Types.GqlPaymentAccountKind | null, paymentAccountNumber?: string | null, paymentName?: string | null, contactId?: string | null, signatoryId?: string | null, snrCaseId?: string | null, updatedAt: string, warrantProgramId: string, regFormPaymentThroughBolago: boolean };

export type GqlOrValidatorErrorFieldsFragment = { decision: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, signatories: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, participants: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, signsRegForm: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, payBeforeDate: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, options: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null }, todos: { completed: boolean, hasError: boolean, severity: Types.GqlSeverity, error?: { sv: { short?: string | null, long?: string | null }, en: { short?: string | null, long?: string | null } } | null } };

export const OrFieldsFragmentDoc = gql`
    fragment OrFields on OptionsRegistration {
  createdAt
  description
  ibanAddress
  ibanBank
  ibanBic
  ibanNumber
  id
  payBeforeDate
  paymentAccountKind
  paymentAccountNumber
  paymentName
  contactId
  signatoryId
  snrCaseId
  updatedAt
  warrantProgramId
  regFormPaymentThroughBolago
}
    `;
export const OrValidatorErrorFieldsFragmentDoc = gql`
    fragment OrValidatorErrorFields on OrValidatorErrors {
  decision {
    ...ValidatorStatusFields
  }
  signatories {
    ...ValidatorStatusFields
  }
  participants {
    ...ValidatorStatusFields
  }
  signsRegForm {
    ...ValidatorStatusFields
  }
  payBeforeDate {
    ...ValidatorStatusFields
  }
  options {
    ...ValidatorStatusFields
  }
  todos {
    ...ValidatorStatusFields
  }
}
    ${ValidatorStatusFieldsFragmentDoc}`;